// extracted by mini-css-extract-plugin
export default {"cont":"FormNpde_cont__32SJO","details":"FormNpde_details__eF0O+","placeholder":"FormNpde_placeholder__7Pov0"};